import {Api, Req} from "@quipa/api";

export const getDraperyOrderPrice = (draperyOrderPriceId: number) =>
    Api.createAction(Api.GET_DRAPERY_ORDER_PRICE, { draperyOrderPriceId }, { authenticated: true });

export const addDraperyOrderPrice = (draperyOrderPrice: Api.AddDraperyOrderPriceAction[Req]) =>
    Api.createAction(Api.ADD_DRAPERY_ORDER_PRICE, draperyOrderPrice);